import { render } from "./ThePreloader.vue?vue&type=template&id=45fc21a2"
import script from "./ThePreloader.vue?vue&type=script&lang=js"
export * from "./ThePreloader.vue?vue&type=script&lang=js"

import "./ThePreloader.vue?vue&type=style&index=0&id=45fc21a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__